exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuLine[data-v-8979eec0] {\n  height: 2px;\n  position: relative;\n  background: #404040;\n  margin: 3px 0px;\n}\n", ""]);

// exports
